import React, { useEffect, useContext, useState } from "react";
import { Row, Col, Form, FormGroup, Label } from "reactstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import { ItemTypeahead, SpinnerButton } from "./";
import { DesktopContainer } from "../layouts";
import { api, UserContext } from "../utils";

export default function BOMMassReplacement(props) {
   const { currentUser } = useContext(UserContext);
   const [bomItem, setBomItem] = useState(null);
   const [countOfReplacements, setCountOfReplacements] = useState(null);
   const [loadingLocs, setLoadingLocs] = useState(false);
   const [possibleLocs, setPossbileLocs] = useState([]);
   const [repItem, setRepItem] = useState(null);
   const [repItemLoc, setRepItemLoc] = useState(null);
   const [working, setWorking] = useState(false);

   useEffect(() => {
      if (!repItem) return;
      setLoadingLocs(true);
      setRepItemLoc(null);
      api.fetch(`BOM/GetItemSites/${repItem.value}`)
         .then((r) => {
            setPossbileLocs(r.data.message);
            setRepItemLoc(r.data.message[0]);
         })
         .catch(api.catchHandler)
         .finally(() => setLoadingLocs(false));
   }, [repItem]);

   function handleMassUpdate() {
      setWorking(true);
      if (
         !currentUser.isAdmin &&
         !currentUser.isPowerUser &&
         !currentUser.isEngineerEdit
      ) {
         toast.error(
            "You need to have one of the following roles to do this action: Admin, PowerUser, EngineerEdit"
         );
         setWorking(false);
         return;
      }
      const payload = {
         bomItem: bomItem.value,
         replacementItem: repItem.value,
         siteId: repItemLoc.value,
      };
      api
         .fetch(`BOM/MassReplaceComponent`, payload)
         .then((r) => {
            if (r.data.success) {
               toast.success("Successfully updated BOM's to use the new component");
            } else {
               toast.error(r.data.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => {
            setWorking(false);
            setBomItem("");
            setRepItemLoc("");
            setRepItemLoc("");
         });
   }

   function handleRepItemChange(opt) {
      setRepItem(opt);
      if (opt === null) {
         setRepItemLoc(null);
         setPossbileLocs([]);
      }
   }

   function onSelectSourceItem(item) {
      setBomItem(item);
      api.fetch(`BOM/MassReplaceComponentCount/${item.value}`).then((r) => {
         setCountOfReplacements(r.data.message);
      }).catch(api.catchHandler)
   }

   return (
      document.title = `BOM Component Mass Replacement`,
      <DesktopContainer screenName="BOM Component Mass Replacement">
         <div className="filter-header mb-5">
            <Row className="justify-content-center align-items-center">
               <Col xs={7}>
                  <Form>
                     <FormGroup row>
                        <Label xs={3} className="text-end">
                           <h5 children="BOM Component Item:" className="text-white" />
                        </Label>
                        <Col xs={9}>
                           <ItemTypeahead value={bomItem} onChange={onSelectSourceItem} />
                        </Col>
                     </FormGroup>
                     <FormGroup row>
                        <Label xs={3} className="text-end">
                           <h5 children="Replacement Item:" className="text-white" />
                        </Label>
                        <Col xs={9}>
                           <ItemTypeahead value={repItem} onChange={handleRepItemChange} />
                        </Col>
                     </FormGroup>
                     <FormGroup row>
                        <Label xs={3} className="text-end">
                           <h5 children="Repl. Item Location:" className="text-white" />
                        </Label>
                        <Col xs={9}>
                           <Select
                              options={possibleLocs}
                              value={repItemLoc}
                              onChange={(opt) => setRepItemLoc(opt)}
                              isLoading={loadingLocs}
                           />
                        </Col>
                     </FormGroup>
                     <SpinnerButton
                        className="shredButton float-end"
                        onClick={handleMassUpdate}
                        on={working}
                        disabled={working || !bomItem || !repItem || !repItemLoc}
                     >
                        Mass Update {countOfReplacements === null ? "" : countOfReplacements} BOMs
                     </SpinnerButton>
                  </Form>
               </Col>
            </Row>
         </div>
      </DesktopContainer>
   );
}
